exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#map {\n  width: 100%;\n  height: 100%; }\n\nh4.ui.header.blue {\n  margin: 1rem 0;\n  border-bottom: 2px solid;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: hidden;\n  display: inline-block;\n  width: 100%;\n  text-overflow: ellipsis; }\n\n.scroll {\n  height: 100%;\n  overflow-y: scroll; }\n\n.full-height {\n  height: 100%; }\n\n.ui.form .field input,\n.ui.form .field textarea {\n  margin: 0.2rem 0; }\n\nbutton.btn-preview {\n  margin-top: 0.4rem; }\n\nbutton.btn-remove.ui.button {\n  margin-top: 0.5rem; }\n\ndiv.action.icon {\n  padding: 1rem; }\n\ndiv.inline {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-left: 1rem; }\n\ndiv.inline label {\n    font-weight: bold;\n    margin-right: 1rem;\n    margin-bottom: 0.4rem; }\n\n.field > label {\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/configurations/configurations-template-tile/configurations-template-tile.component.scss
// module id = ../../../../../src/app/configurations/configurations-template-tile/configurations-template-tile.component.scss
// module chunks = main